import { useMemo } from 'react'

import { FileState } from 'ui/components/FileUpload/types'
import { useId } from 'ui/helpers/useId'

import { FileUploadItemContextValue } from './useFileUploadItemContext'

type UseFileUploadFileListItemStateProps = {
    value: FileState
}

export function useFileUploadFileListItemState({ value }: UseFileUploadFileListItemStateProps) {
    const id = useId()
    const statusId = `${id}-status`
    const nameId = `${id}-name`
    const sizeId = `${id}-size`

    const error = value?.error

    const statusText = useMemo(() => {
        if (error) return `Error: ${error}`
        switch (value?.status) {
            case 'error':
                return `Error: ${error}`
            case 'uploading':
                return `Uploading: ${value.progress}% complete`
            case 'success':
                return 'Upload complete'
            default:
                return 'Ready to upload'
        }
    }, [error, value])

    const itemContext: FileUploadItemContextValue = useMemo(
        () => ({
            id,
            nameId,
            sizeId,
            statusId,
            fileState: value,
        }),
        [id, nameId, sizeId, statusId, value]
    )

    return {
        id,
        nameId,
        sizeId,
        statusId,
        itemContext,
        statusText,
    }
}
